import { Stack, Flex, Copy } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IReceiptLineItemProps {
  title: string;
  subtitle?: React.ReactNode;
  amount: string;
  newAmount?: string;
  color?: React.ComponentProps<typeof Copy>['color'];
}

export function ReceiptLineItem({
  title,
  subtitle,
  amount,
  newAmount,
  color,
}: IReceiptLineItemProps): JSX.Element {
  return (
    <Flex justifyContent="space-between">
      <Flex>
        <Copy variant="lead" strong color={color ?? 'secondaryText'}>
          {title}
        </Copy>
        {subtitle}
      </Flex>
      <Flex justifyContent="flex-end">
        <Stack x={newAmount ? 'xxx-sm' : 'none'}>
          <Copy
            variant="lead"
            strong
            color={color ?? 'primaryText'}
            style={{ textDecoration: newAmount ? 'line-through' : 'none' }}
          >
            {amount}
          </Copy>
        </Stack>
        {newAmount && (
          <Copy variant="lead" strong color="success">
            {newAmount}
          </Copy>
        )}
      </Flex>
    </Flex>
  );
}
